import Model from './model';

export default class RoutesModel extends Model {
  url: string;
  microService?: string
  status?: Status;
  feature: Array<IFeature>;

  constructor() {
    super();
    this.feature = new Array();
  }
}

//////////////////////////////
//IFeature
//////////////////////////////
export class IFeature {
  name: string;
  function: Array<IFunction>;
  product: Array<IProduct>;
  screen: Array<IScreen>;

  constructor() {
    this.function = new Array();
    this.product = new Array();
    this.screen = new Array();
  }
}

//////////////////////////////
//IFunction
//////////////////////////////
export class IFunction {
  name: string;

  constructor() { }
}

//////////////////////////////
//IProduct
//////////////////////////////
export class IProduct {
  name: string;

  constructor() { }
}

//////////////////////////////
//IScreen
//////////////////////////////
export class IScreen {
  name: string;

  constructor() { }
}

export type Status = 'Active' | 'Inactive' | 'In Progress';